import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default class CanAccessFeatureHelper extends Helper {
  @service featureAccess;

  compute([feature]) {
    return this.featureAccess.canAccessFeature(feature);
  }
}
